import { Link } from "@/i18n/navigation";
import { ComponentProps } from "react";

type LinkProps = ComponentProps<typeof Link> & {
  title: string;
};

const MainLink = ({ ...props }: LinkProps) => {
  return (
    <Link
      href={props.href}
      className={`bg-primary border-primary lg:hover:bg-background lg:hover:text-primary flex min-h-11 items-center justify-center rounded-none border-2 px-6 py-2.5 text-center text-sm leading-snug font-bold text-white shadow-xs transition-[background-color,border-color,color,box-shadow] duration-300 *:h-5 ${props.className ?? ""}`}
    >
      {props.title}
    </Link>
  );
};

export default MainLink;
